import React from 'react';
import { Link } from 'react-router-dom';
import './TopicCard.css';

const TopicCard = ({ topicName, questionCount }) => {
    return (
        <div className="topic-card">
            <div className="topic-card-body">
                <div className="topic-card-topline">
                    <span className="topic-card-badge">Topic</span>
                    <span className="topic-card-count">{questionCount || 0} Questions</span>
                </div>
                <h3 className="topic-title">{topicName}</h3>
                <p className="topic-description">Open the login page to continue and access this topic from your account.</p>
                <Link to="/login" className="topic-btn">
                    Learn More
                </Link>
            </div>
        </div>
    );
};

export default TopicCard;
